import * as luxon from 'luxon';

import { flagListEquals, isEmptyOrSpace } from '../../../../webmodule-common/other/ui/string-helper-functions';
import { getApiFactory } from '../../../api/api-injector';

import { QuoteApi } from '../../../api/quote-api';
import { QuoteState, ViewQuoteTotalByState } from '../../../api/dealer-api-interface-quote';

export class DashboardCache {
  numberOfDays = Math.ceil(Math.abs(luxon.DateTime.local().startOf('month').diffNow('days').days));

  get quoteApi(): QuoteApi {
    return getApiFactory().quote();
  }

  resetData(branchIds: string[], selectedBranchId?: string) {
    const p = async () => {
      const result = await this.quoteApi.getQuoteTotalsByState({
        quoteOwnerId: selectedBranchId ? [selectedBranchId] : branchIds,
        options: [
          { state: [QuoteState.Draft], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.Active], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.Issued], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.Accepted], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.Rejected], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.Lapsed], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.Cancelled], numberOfDaysHistory: this.numberOfDays },
          { state: [QuoteState.IssuePending], numberOfDaysHistory: this.numberOfDays }
        ]
      });

      return result?.totals ?? null;
    };
    this.quoteFinancialSummaryDataForMonthPromise = p();
  }
  quoteFinancialSummaryDataForMonthPromise?: Promise<ViewQuoteTotalByState[] | null>;

  /**filter all items by state, or user or both or none */
  async getMonthlyQuoteFinancials(state?: QuoteState, userId?: string) {
    const quoteFinancialSummaryDataForMonth: ViewQuoteTotalByState[] | null =
      (await this.quoteFinancialSummaryDataForMonthPromise) ?? null;
    return (
      quoteFinancialSummaryDataForMonth?.filter(
        x => (!state || flagListEquals(x.quoteState, [state])) && (isEmptyOrSpace(userId) || userId === x.userId)
      ) ?? []
    );
  }
}

let _db: DashboardCache | null = null;
export function flushDashboard() {
  _db = null;
}
export function dashboard(): DashboardCache {
  if (!_db) {
    _db = new DashboardCache();
  }
  return _db;
}
